import localDb from '@util/localDb';
import {queryAccountInfo} from '@api/core/user';

// 按模块的action, reducer整合体
const SET_USER = 'SET_USER';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

// Action
export function setUser() {
  return dispatch => {
    return queryAccountInfo().then(req => {
      localDb.set('user', req.data);
      return {
        type: SET_USER,
        user: req.data,
      };
    });
  };
}

export function cleanUser() {
  return {
    type: SET_USER,
    user: {},
  };
}

// Reducer
export function user(state = {}, action) {
  switch (action.type) {
    case SET_USER:
      return action.user;
    case LOGIN_SUCCESS:
      return action.data;
    default:
      return localDb.get('user');
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js